
import { Link } from 'react-router-dom';
import Button from './Button';

interface ProductCardProps {
  id: string;
  name: string;
  price: number;
  originalPrice?: number;
  image: string;
  description: string;
  tags?: string[];
  onAddToCart?: () => void;
}

export default function ProductCard({
  id,
  name,
  price,
  originalPrice,
  image,
  description,
  tags = [],
  onAddToCart
}: ProductCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-200" data-product-shop>
      <Link to={`/product/${id}`}>
        <div className="aspect-square overflow-hidden rounded-t-lg">
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-200"
          />
        </div>
      </Link>
      
      <div className="p-4">
        <Link to={`/product/${id}`}>
          <h3 className="font-semibold text-gray-800 mb-2 hover:text-orange-500 transition-colors line-clamp-2">
            {name}
          </h3>
        </Link>
        
        <p className="text-sm text-gray-600 mb-3 line-clamp-2">
          {description}
        </p>
        
        {tags.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-3">
            {tags.map((tag, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-orange-100 text-orange-600 text-xs rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
        
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <span className="text-lg font-bold text-orange-500">
              ¥{price.toFixed(2)}
            </span>
            {originalPrice && originalPrice > price && (
              <span className="text-sm text-gray-400 line-through">
                ¥{originalPrice.toFixed(2)}
              </span>
            )}
          </div>
          
          <Button
            size="sm"
            onClick={onAddToCart}
            className="flex items-center space-x-1"
          >
            <i className="ri-shopping-cart-line"></i>
            <span>加购</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
